/**
 * Builds the DOM id for a palette option so the listbox and the combobox
 * input's `aria-activedescendant` stay in sync.
 */
export const getOptionId = (listboxId: string, index: number) =>
  `${listboxId}-option-${index}`;
